// The current featured season / launch push.

export const LAUNCH = {
  eyebrow:"SUNDAY · AUGUST 2 · 9:30 & 11:30 AM",
  title:"BACK TO SCHOOL. BACK IN THE ROOM.",
  intro:"One Sunday. Two services. A brand new rhythm for CLLXTV — and a whole city's worth of families walking in the door.",
  blocks:[
    {
      h:"What's happening",
      p:"Free haircuts and ladies' style cuts. Free backpacks. Two full services at 9:30 and 11:30 AM. This is our biggest front door of the year — and the first Sunday of the two-service era."
    },
    {
      h:"Why two services",
      p:"The room is filling up. Two services means more seats, more parking, more room for guests to say yes to an invite. History doesn't happen in a packed lobby — it happens in a seat."
    },
    {
      h:"What your team does",
      p:"Every team serves both services with a break between. Your leader will confirm your assignment in your team GroupMe the week before. Arrive early, bring energy, expect families who've never been in the room."
    },
    {
      h:"Your one job before Aug 2",
      p:"Invite one family. One. A neighbor, a coworker, a parent from the school pickup line. Free haircuts and backpacks make this the easiest invite of the year."
    }
  ]
};
